<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">CAMBIAR CONTRASEÑA</h4>
                                    <p>POR FAVOR INGRESE SU NUEVA CONTRASEÑA.</p>
                                </div>
                                 
                                <vs-input 
                                type="password" 
                                data-vv-validate-on="blur" 
                                v-validate="'required'" 
                                name="old_password" 
                                label-placeholder="Password" 
                                placeholder="Contraseña Anterior" 
                                v-model="old_password" 
                                class="w-full mb-6" /> 
                                <span class="text-danger text-sm">{{ errors.first('old_password') }}</span> 
 
                                <vs-input
                                ref="password"
                                type="password"
                                data-vv-validate-on="blur"
                                v-validate="'required'"
                                name="password"
                                label-placeholder="Password"
                                placeholder="Nueva Contraseña"
                                v-model="password"
                                class="w-full mb-6" />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <vs-input
                                type="password"
                                v-validate="'confirmed:password'"
                                data-vv-validate-on="blur"
                                data-vv-as="password"
                                name="confirm_password"
                                label-placeholder="Confirm Password"
                                placeholder="Confirmar Contraseña"
                                v-model="confirm_password"
                                class="w-full mb-8" />
                                <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>


                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button class="w-full sm:w-auto" @click="changePassword" :disabled="!validateForm">GUARDAR</vs-button>
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">VOLVER AL INICIO DE SESIÓN</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import auth from '@/auth/authService'

var user = null;

export default {
  data () {
    return {
      old_password: '',
      password: '',
      confirm_password: ''
    }
  },
   computed: {
    validateForm () {
      return !this.errors.any() && this.old_password !== '' && this.password !== '' && this.confirm_password !== ''; 
    }
  },
  created () {
      user = this.$route.params;
  },
  methods: {
changePassword () { 
 
        axios.put('' + auth.connectionFrontEnd() + '/webapi/updatePasswordClientEC', 
        { 
            codemp: user.comp, 
            rucced: user.user, 
            clipswOld: this.old_password,
            clipsw: this.password 
        },  
         
        { headers: { token: auth.getToken() } } 
 
        ).then(response => { 
 
            if(response.data.success == true){ 
                this.password= ''; 
                this.confirm_password= ''; 
                this.$vs.notify({ 
                      title: 'Contraseña Guardada', 
                      text: 'Contraseña Guardada correctamente', 
                      iconPack: 'feather', 
                      icon: 'icon-save', 
                      color: 'success' 
                });  
                localStorage.clear(); 
                sessionStorage.clear(); 
                this.$router.push({  
                  name: "page-login"  
                }); 
            } else{ 
                this.$vs.notify({ 
                  title: 'Error Contraseña Anterior', 
                  text: 'Error Contraseña Anterior Incorrecta, Intente de nuevo', 
                  iconPack: 'feather', 
                  icon: 'icon-alert-circle', 
                  color: 'danger' 
                })  
                  }    
 
 
              }).catch(e => { 
                this.$vs.notify({ 
                    title: 'Error', 
                    text: 'Problema con el Servidor, Intente más tarde', 
                    iconPack: 'feather', 
                    icon: 'icon-alert-circle', 
                    color: 'danger' 
                  }) 
                
              }) 
 
    }, 
  }
}
</script>
